import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Avatar } from "./pages/avatar/avatar";
import { Login } from "./pages/auth/Login/Login";
import { ForgotPassword } from "./pages/auth/ForgotPassword/ForgotPassword";
import { ResetPassword } from "./pages/auth/ResetPassword/ResetPassword";

import { MobileDebugOverlay } from "./components/debug/mobile-debug-overlay";

import { applyStoredSystemLanguage } from "./common/system-language";
import { useSsoCallback } from "./common/useSsoCallback";
import Preloader from "./components/preloader/preloader";

// Inside the Router so the SSO hook can navigate. While an SSO return is being
// exchanged no route is mounted, otherwise the avatar would render as a guest for the
// duration of the round-trip and then flip to a signed-in session.
function AppRoutes() {
  const { processing } = useSsoCallback();

  if (processing) return <Preloader />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/share/:token" element={<Avatar />} />
      <Route path="/chat/:sessionId" element={<Avatar />} />
      <Route path="/" element={<Avatar />} />
      {/* Catch-all route redirects to login */}
      <Route path="*" element={<Login />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    applyStoredSystemLanguage();
  }, []);

  return (
    <Router>
      <AppRoutes />
      <ToastContainer />
      {/* No-op unless the URL has ?debug=1 — an on-screen console for phone testing. */}
      <MobileDebugOverlay />
    </Router>
  );
}

export default App;
